"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
function AudioStream(_a) {
    var mediaStream = _a.mediaStream;
    var audioEl = react_1.useRef(null);
    react_1.useEffect(function () {
        var audioElementInterval = setInterval(function () {
            if (audioEl && audioEl.current && audioEl.current.ended) {
                // eslint-disable-next-line
                audioEl.current.srcObject = audioEl.current.srcObject;
            }
        }, 250);
        // @ts-ignore
        return function cleanup() {
            if (audioElementInterval)
                clearInterval(audioElementInterval);
        };
    }, []);
    react_1.useEffect(function () {
        if (audioEl.current && mediaStream) {
            audioEl.current.srcObject = mediaStream;
            audioEl.current.play();
        }
    }, [mediaStream]);
    return react_1.default.createElement("audio", { autoPlay: true, ref: audioEl });
}
exports.default = AudioStream;
